// extracted by mini-css-extract-plugin
module.exports = {"senior_offers":"senioroffers_senior_offers__1m8Y5","button":"senioroffers_button__2sY98","button_cab":"senioroffers_button_cab__9A245","outdated":"senioroffers_outdated__3rL-S"};